import React from "react";

import styles from "./BrandedDeepDiveHeader.css";

export default function BrandedDeepDiveHeader() {
  return (
    <div className={styles.root}>
      <h2 className={styles.subheader}>
        <em>Partner content from JPMorgan Chase & Co.</em>
      </h2>
      <h1 className={styles.header}>Smarter Faster: Cities</h1>
      <p className={styles.text}>
        A video series that explores new paths to opportunity in communities
        across the country.
      </p>
    </div>
  );
}
